import styled from 'styled-components';
import {
  backgroundShape,
  borderShape,
  getColor,
  getTextType,
  getSpace,
  mq,
  px2rem
} from '../../../../../stylesheets/tools';

const StyledTeaser = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${getSpace('l')};

  ${mq('m')} {
    flex-direction: row;
    margin-bottom: ${getSpace('xs')};
  }

  .teaser__meta {
    display: flex;
    justify-content: space-between;
    align-items: start;
    white-space: nowrap;
    margin-bottom: ${getSpace('xxs')};
    flex-direction: row-reverse;

    ${mq('m')} {
      flex-direction: column;
      justify-content: flex-start;
      margin-bottom: 0;
      margin-right: ${getSpace('l')};
    }

    .teaser__time {
      color: ${getColor('teaserGray')};

      ${mq('m')} {
        margin-top: 15px;
      }
    }
    .teaser__tag {
      &--bookable .filter-tag:before {
        color: ${props => props.theme.siteTheme.secondary};
      }
      &--open .filter-tag {
        color: ${props => props.theme.siteTheme.secondary};
      }
    }
  }

  .teaser__book-btn-container {
    display: flex;
    width: 100%;
    text-transform: uppercase;

    .teaser__button--disabled {
      opacity: 0.25;
    }

    a {
      width: 100%;
      text-align: center;
      padding: ${px2rem('15px')} ${px2rem('20px')};

      ${borderShape()};
      &:hover:not(.teaser__button--disabled) {
        color: #fff;
        ${backgroundShape()};
      }
    }
  }

  .teaser__image {
    aspect-ratio: 4/3;
    object-fit: cover;

    ${mq('m')} {
      max-width: auto;
      height: ${px2rem('155px')};
      margin-right: ${getSpace('m')};
    }
  }

  .teaser__text {
    display: flex;
    flex-direction: column;
    margin: ${getSpace('xs')} auto auto auto;
    width: 100%;

    ${mq('m')} {
      margin: unset;
    }
    * {
      ${getTextType('subline')};
    }

    .teaser__page-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      margin-right: auto;
      margin-bottom: ${getSpace('xs')};

      ${mq('m')} {
        margin-bottom: ${getSpace('xxs')};
      }
    }

    h3 {
      line-height: 1.25;
      margin-bottom: ${px2rem('8px')};
      font-size: 20px;

      ${mq('m')} {
        font-size: 18px;
      }
    }

    & > div:not(.teaser__page-tags) * {
      ${getTextType('copySmall', 'international')};
      color: ${getColor('teaserGray')} !important;
      margin-left: 0;
      margin-right: 0;
      height: min-content;
      line-height: 1.75;
    }

    & > div p {
      margin-top: ${getSpace('xs')};
      margin-bottom: ${getSpace('xs')};
    }
  }

  .teaser__book-btn {
    margin: ${getSpace('xs')} 0 0 0;
    white-space: nowrap;
    font-size: 14px;
    border: none;

    ${mq('m')} {
      margin: auto 0 auto ${getSpace('l')};
      width: min-content;
    }

    a,
    button {
      width: 100%;
      justify-content: center;
      border-left: unset;

      ${mq('m')} {
        justify-content: flex-start;
        width: min-content;
      }
    }
    a {
      display: block;
    }
  }
`;

export default StyledTeaser;
